import { ModalProgressBar } from "components/HelperComponents/ModalProgressBar";
import showToast from "helpers/showToast";
import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

function ConfirmeDialog({
  show,
  onHide,
  submit,
  modalTitle = "DIALOG.DELETERECORD",
  modalMessage = "DIALOG.DELETEMESSAGE",
  confirmMessage = "DIALOG.CONFIRM",
  backdrop = true
}) {
  const [isLoading, setIsLoading] = useState(false);

  async function confirmDialog() {
    if (submit && typeof submit === "function") {
      setIsLoading(true);
      try {
        await submit();
      } finally {
        setIsLoading(false);
      }
    } else {
      showToast("ERROR.UNKNOWN", { type: "error" });
    }
  }
  return (
    <Modal
      show={show}
      onHide={onHide}
      keyboard={!isLoading}
      backdrop={isLoading ? "static" : backdrop}
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={modalTitle} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id={modalMessage} />
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            id="dialog-cancel"
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mr-2"
            disabled={isLoading}
          >
            <FormattedMessage id="DIALOG.CANCEL" />
          </button>
          <button
            id="dialog-confirmdelete"
            type="button"
            onClick={confirmDialog}
            className="btn btn-light-primary btn-elevate"
            disabled={isLoading}
          >
            <FormattedMessage id={confirmMessage} />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmeDialog;
